import React, { Component, PropTypes } from 'react';
import DocumentMeta from 'react-document-meta';
import TopMenu from '../../components/TopMenu';
import {ModalWindowContainer} from 'reactis-modal';
import NotificationSystem from 'react-notification-system';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import EventEmitter from '../../EventEmitter';

export default class App extends Component {
	static propTypes = {
		children: PropTypes.object.isRequired
	};

	static childContextTypes = {
		flashMessage: React.PropTypes.func,
		setNavBarButtons: React.PropTypes.func,
		setNavBarTitle: React.PropTypes.func,
		setNavBarHomeButton: React.PropTypes.func
	};

	getChildContext() {
		return {
			flashMessage: this.flashMessage.bind(this),
			setNavBarButtons: this.setNavbarButtons.bind(this),
			setNavBarTitle: this.setNavbarTitle.bind(this),
			setNavBarHomeButton: this.setNavbarHomeButton.bind(this)
		}
	}

	constructor(props) {
		super(props);
		this.updateDimensions = this.updateDimensions.bind(this);
		this.state = {
			buttons: [],
			title: null,
			homeButton: null
		}
	}

	setNavbarButtons(buttons) {
		this.setState({buttons});
	}

	setNavbarTitle(title) {
		this.setState({title});
	}

	setNavbarHomeButton(button) {
		this.setState({homeButton:button});
	}

	flashMessage(msg, level = 'success') {
		if (__MOBILE__) {
			window.plugins.toast.showShortBottom(msg.message);
		}
		else {
			msg.level = level;
			msg.position = 'br';
			msg.autoDismiss = 3;
			this.notificationSystem.addNotification(msg);
		}
	}

	componentDidMount() {
		this.notificationSystem = this.refs.notificationSystem;
		EventEmitter.on('onPushNotification', (data) => {
			if (!data.wasTapped) {
				window.plugins.toast.showShortBottom(data.message);
			}
		});
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	updateDimensions() {
		this.forceUpdate();
	}

	render() {
		const style = {
			Dismiss: {
				DefaultStyle: {
					borderRadius: '0px',
					backgroundColor: '#CCC'
				}
			},

			NotificationItem: { // Override the notification item
				DefaultStyle: { // Applied to every notification, regardless of the notification level
					borderRadius: '0px',
					isVisible: {
						opacity: 1
					}
				},

				success: {
					backgroundColor: '#FFFFFF',
					borderTop: '2px solid rgb(33, 150, 243)',
					boxShadow: 'rgba(33, 150, 243, 0.9) 0px 0px 1px'
				}
			}
		};
		const isPhone = window.matchMedia("only screen and (max-width: 768px)").matches;
		return (
			<div>
				<ModalWindowContainer />
				<TopMenu buttons={this.state.buttons}
						 title={this.state.title}
						 homeButton={this.state.homeButton}
						 isPhone={isPhone}
						 {...this.props} />
				<div className="page-container">
					<div className="page-content">
						<div className="content-wrapper">
							{this.props.children}
						</div>
					</div>
				</div>
				<NotificationSystem ref="notificationSystem" style={style} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/App/AppWithMenu.js